export default __webpack_public_path__ + "static/media/twitter.af8d0c30.svg";